import { formatCurrency } from '../../../components/design-system/admin/format';

/**
 * Money on the billing and sales pages: whole amounts without decimals ($750),
 * fractional ones with them ($49.50), in the active language.
 */
export function formatMoney(amount: number | null | undefined, currency?: string | null): string {
  const value = Number(amount ?? 0);
  return formatCurrency(value, (currency || 'usd').toLowerCase(), Number.isInteger(value) ? 0 : 2);
}

/** Amounts added up per currency — invoices and quotes can mix currencies, and a sum across them means nothing. */
export function sumByCurrency<T>(items: T[], amount: (item: T) => number | null | undefined, currency: (item: T) => string | null | undefined): Map<string, number> {
  const totals = new Map<string, number>();
  for (const item of items) {
    const value = Number(amount(item) ?? 0);
    if (!value) continue;
    const code = (currency(item) || 'usd').toLowerCase();
    totals.set(code, (totals.get(code) || 0) + value);
  }
  return totals;
}

/** "$1,200 · €300", or the zero amount in the default currency when there is nothing. */
export function formatTotals(totals: Map<string, number>, fallbackCurrency = 'usd'): string {
  if (!totals.size) return formatMoney(0, fallbackCurrency);
  return Array.from(totals.entries())
    .sort((a, b) => b[1] - a[1])
    .map(([code, value]) => formatMoney(value, code))
    .join(' · ');
}
